<template>
  <j-modal
    :title="title"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <!-- form 
      @keyup.enter.native="handleOk"-->
      <a-form :form="form" @keyup.enter.native="handleOk">
        <!-- 施設種類名称 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.facilityType')">
          <j-dict-select-tag
            :placeholder="this.$t('disp.ph.select.default')"
            dictCode="sys_facility_type;FACILITY_TYPE_NAME;ID;DEL_FLAG='0'"
            v-decorator="['facilityTypeId', validatorRules.facilityTypeId]"
            :triggerChange="true"
            :disabled="facilityTypeDisabled"
            :cache="false"
          />
        </a-form-item>
        <!-- 施設名称 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.ficilityName')">
          <a-input
            :placeholder="this.$t('disp.facilityInput')"
            v-decorator="['facilityName', validatorRules.facilityName]"
            :maxLength="90"
          />
        </a-form-item>
        <!-- 备注 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.note')">
          <a-textarea
            :rows="5"
            @keyup.enter.stop
            v-decorator="['memo']"
            :maxLength="255"
            style="resize: none"
            :placeholder="this.$t('disp.memoInput')"
          />
        </a-form-item>
        <!-- 参考人数 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考人数">
          <j-input-number
            style="width: 104px"
            placeholder="参考人数"
            v-decorator="['peopleNumberMax']"
            :min="0"
            :max="999"
          />
        </a-form-item>
        <!-- 施設画像 -->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.facilityImg')">
          <a-upload
            accept="image/png,image/jpeg,image/jpg"
            :action="uploadAction"
            list-type="picture-card"
            :file-list="fileList"
            :data="{ biz: bizPath }"
            :beforeUpload="beforeUpload"
            @preview="handlePreview"
            @change="handleChange"
            :headers="headers"
            v-decorator="['attachedFile']"
            class="avatar-uploader"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text"></div>
            </div>
          </a-upload>
          <!-- modal -->
          <a-modal
            centered
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancelPre"
            :title="$t('disp.preview')"
            :width="800"
          >
            <!-- プレビュー -->
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>
        <!--	ソート順　-->
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('disp.sort')" style="margin-top: -20px">
          <j-input-number
            style="width: 104px"
            :placeholder="$t('disp.sort')"
            v-decorator="['sortOrder', validatorRules.sortOrder]"
            @change="sortOrderChange"
            :min="0"
            :max="999"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>
<script>
import pick from 'lodash/pick'
import { addRole, editRole, duplicateCheck } from '@/api/api'
import JImageUpload from '@/components/JImageUpload'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import { httpAction, getAction, postAction, putAction } from '@/api/manage'
import JInputNumber from '@/components/JInputNumber'
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getFileAccessHttpUrl } from '@/api/manage'
export default {
  name: 'FacilityModal',
  components: {
    // JImageUpload
    JImageUpload,
    // JDictSelectTag
    JDictSelectTag,
    // JInputNumber
    JInputNumber,
  },
  data() {
    return {
      // アップロード
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload',
      // url
      urlView: window._CONFIG['staticDomainURL'],
      // ローディング
      uploadLoading: false,
      // 図
      picUrl: false,
      // ヘッダー
      headers: {},
      // fileList
      fileList: [],
      // previewImage
      previewImage: '',
      // previewVisible
      previewVisible: false,
      // データ
      data: '',
      // タイトル
      title: '',
      // value
      value: '',
      // 施設種別
      facilityTypeId: '',
      // visible
      visible: false,
      // facilityTypeDisabled
      facilityTypeDisabled: false,
      model: {},
      // 図リスト
      imgList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      // ローディング
      loading: false,
      form: this.$form.createForm(this),
      // チェック
      validatorRules: {
        facilityName: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
            {
              validator: this.validateFacilityName,
            },
          ],
        },
        facilityTypeId: {
          rules: [
            {
              required: true,
              message: this.$t('disp.rules.require'),
            },
          ],
        },
        sortOrder: { initialValue: 1.0 },
        description: {},
      },
    }
  },
  props: {
    bizPath: {
      type: String,
      required: false,
      default: '设施',
    },
  },
  watch: {},
  // token
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const dds = Vue.ls.get('DDS')
    this.headers = { 'X-Access-Token': token, DDS: dds }
  },
  methods: {
    /**
     * 写真のフォーマット変換
     */
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    /**
     * プレビュー
     */
    handleCancelPre() {
      this.previewVisible = false
    },
    // 図
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      if (file.url.indexOf('http') == 0) {
        this.previewImage = file.url
      } else {
        if (file.url) {
          this.previewImage = this.urlView + '/' + file.url
        } else {
          this.previewImage = file.preview
        }
      }
      // previewVisible
      this.previewVisible = true
    },
    /**
     * アップロード
     */
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning(this.$t('disp.imgSelect'))
          return reject(false)
        }
        return resolve(true)
      })
    },
    /**
     * handleChange
     */
    handleChange(info) {
      this.picUrl = false
      let fileList = info.fileList
      if (fileList.length > 1) {
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.picUrl = true
          fileList = fileList.map((file) => {
            if (file.response) {
              file.url = file.response.message
            }
            return file
          })
        }
      } else if (info.file.status === 'error') {
        this.$message.error(this.$t('disp.uploadFail'))
      }
      this.fileList = fileList
      if (info.file.status === 'done') {
        this.handlePathChange()
      }
    },
    /**
     * 項目編集：
     * 画像にフォーカスする場合、削除アイコンとプレビューアイコンを表示します。
     */
    handlePathChange() {
      let uploadFiles = this.fileList
      let path = ''
      if (!uploadFiles || uploadFiles.length == 0) {
        path = ''
      }
      let arr = []
      if (!this.isMultiple) {
        arr.push(uploadFiles[uploadFiles.length - 1].response.message)
      } else {
        for (var a = 0; a < uploadFiles.length; a++) {
          arr.push(uploadFiles[a].response.message)
        }
      }
      if (arr.length > 0) {
        path = arr.join(',')
      }
      this.$emit('change', path)
    },
    /**
     * getAvatarView
     */
    getAvatarView(fileList) {
      if (fileList != '' && fileList != null) {
        if (fileList.length > 0) {
          let url = this.fileList[0].url
          //
          return url
        }
      }
    },
    /**
     * getAvatarViewHttp
     */
    getAvatarViewHttp(fileList) {
      if (fileList != '' && fileList != null) {
        let url = fileList
        let ddsPara = '/' + Vue.ls.get('DDS')
        return getFileAccessHttpUrl(url, this.urlView + ddsPara, 'http')
      }
    },
    /**
     * 施設名チェック
     */
    validateFacilityName(rule, value, callback) {
      if (!value) {
        callback()
      } else {
        let params = {
          // テーブル名
          tableName: 'sys_facility',
          // fieldName
          fieldName: 'FACILITY_NAME',
          // value
          fieldVal: value,
          // id
          dataId: this.model.id,
        }
        duplicateCheck(params).then((res) => {
          res.success ? callback() : callback(this.$t('disp.rules.duplicate', [this.$t('disp.ficilityName')]))
        })
      }
    },
    /**
     * @description ソート順が空白の場合
     */
    sortOrderChange(e) {
      if (e == '' || e == null) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            sortOrder: 0,
          })
        })
      }
    },
    /**
     * 追加
     */
    add() {
      this.edit({})
    },
    /**
     * 編集
     */
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      // 表示する
      this.visible = true
      if (this.model.id) {
        this.fileList = []
        if (record.attachedFile != null && record.attachedFile != '') {
          var img = {
            uid: '-1',
            name: 'image.png',
            status: 'done',
            url: this.getAvatarViewHttp(record.attachedFile),
          }
          this.fileList.push(img)
        }
        this.facilityTypeDisabled = false
      } else {
        this.fileList = []
        this.$nextTick(() => {
          this.form.setFieldsValue({ facilityTypeId: this.data.id })
        })
        this.facilityTypeDisabled = true
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'facilityTypeId', 'facilityName', 'memo', 'peopleNumberMax', 'attachedFile', 'sortOrder')
        )
      })
    },
    /**
     * 閉じる
     */
    close() {
      this.$emit('close')
      // 非表示にする
      this.visible = false
    },
    /**
     * 確定
     */
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }
      const that = this
      // チェック
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values)
          this.facilityTypeId = formData.facilityTypeId
          if (formData.attachedFile != null && formData.attachedFile != '' && formData.attachedFile.fileList) {
            formData.attachedFile = this.getAvatarView(formData.attachedFile.fileList)
          }
          let obj
          if (!this.model.id) {
            let facilityTypeId = this.facilityTypeId
            let arr = [{ facilityTypeId: facilityTypeId }]
            formData.facilityTypeId = arr[0].facilityTypeId
            let url = '/kgms/k04/FacilitiesManage/addFacility'
            postAction(url, formData)
              .then((res) => {
                if (res.success) {
                  // 提示内容：追加しました。
                  that.$message.success(this.$t(res.message))
                  that.$emit('emit')
                }
              })
              .finally(() => {
                // ローディング終了
                that.loading = false
                // 閉じる
                that.close()
              })
          } else {
            let url = '/kgms/k04/FacilitiesManage/editFacility'
            putAction(url, formData)
              .then((res) => {
                if (res.success) {
                  // 提示内容：編集しました。
                  that.$message.success(this.$t(res.message))
                  that.$emit('emit')
                }
              })
              .finally(() => {
                // ローディング終了
                that.loading = false
                // 閉じる
                that.close()
              })
          }
        } else {
          // ローディング終了
          that.loading = false
        }
      })
    },
    // キャンセル
    handleCancel() {
      // 閉じる
      this.close()
    },
  },
}
</script>
<style scoped></style>
